const US_COUNTRY_VALUES = new Set([
  "usa",
  "us",
  "u.s.",
  "u.s.a.",
  "united states",
  "united states of america",
]);

export function countryUsesState(country?: string | null): boolean {
  if (!country) return false;
  return US_COUNTRY_VALUES.has(country.trim().toLowerCase());
}

export function formatLocationLine(city?: string | null, state?: string | null, country?: string | null): string {
  const parts = [city?.trim(), countryUsesState(country) ? state?.trim() : "", country?.trim()].filter(Boolean);
  return parts.join(", ");
}
